import React from 'react';
import classes from './Footer.module.css';

const Footer = () => {
  return (
    <div className={classes.footer}>
      <h4 className={classes.footerText}>Copyright &copy; 2023 Staflate</h4>
    </div>
  )
}

export default Footer
